import { render, staticRenderFns } from "./ChatbotMenu.vue?vue&type=template&id=053ddb62"
import script from "./ChatbotMenu.vue?vue&type=script&lang=js"
export * from "./ChatbotMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatbotMenu.vue?vue&type=style&index=0&id=053ddb62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports